export function dataURLToBlob(dataURL: string) {
	const BASE64_MARKER = ';base64,';
	if (dataURL.indexOf(BASE64_MARKER) === -1) {
		const parts = dataURL.split(',');
		const contentType = parts[0].split(':')[1];
		const raw = parts[1];
		return new Blob([raw], { type: contentType });
	}
	const parts = dataURL.split(BASE64_MARKER);
	const contentType = parts[0].split(':')[1];
	const raw = window.atob(parts[1]);
	const rawLength = raw.length;
	const uInt8Array = new Uint8Array(rawLength);
	for (let i = 0; i < rawLength; ++i) {
		uInt8Array[i] = raw.charCodeAt(i);
	}
	return new Blob([uInt8Array], { type: contentType });
}

export function sanitizeImage(f: File, s: number = 2048) {
	return new Promise((resolve) => {
		const fileReader = new FileReader();
		const image = new Image();
		let filename = `${Math.random().toString(36).slice(2)}-${f.name}`;
		filename = filename.replace(/ /g, '_').toLowerCase();

		image.addEventListener('load', () => {
			let w = image.width; let
				h = image.height;

			if (s > 0) {
				if (w > h) {
					if (w > s) { h *= (s / w); w = s; }
				} else if (h > s) { w *= (s / h); h = s; }
			}

			const canvas = document.createElement('canvas');
			canvas.width = w;
			canvas.height = h;

			const ctx = canvas.getContext('2d');
			if (!ctx) { return; }
			ctx.drawImage(image, 0, 0, w, h);

			const data = canvas.toDataURL('image/jpeg');
			const blob = dataURLToBlob(data);
			blob.name = filename;

			resolve({ data, blob });
		});

		fileReader.addEventListener('load', (e) => {
			image.src = ((e.target as FileReader).result) as string;
		});

		fileReader.readAsDataURL(f);
	});
}

export function rotatePhoto(src: string) {
	return new Promise((ok) => {
		const img = new Image();
		img.src = src;
		img.onload = () => {
			const cvs = document.createElement('canvas');
			cvs.width = img.height;
			cvs.height = img.width;
			cvs.style.position = 'absolute';

			const ctx = cvs.getContext('2d');
			if (!ctx) { return; }
			ctx.translate(img.height, img.width / img.height);
			ctx.rotate(Math.PI / 2);
			ctx.drawImage(img, 0, 0);

			ok(cvs.toDataURL('image/jpeg'));
		};
	});
}
